import { useLocation, useParams } from 'react-router-dom';

import { AllRegistrationScreenParams, RegistrationCommonStep, RegistrationStep } from '../../../utils/navigation';
import { Energimerkeversjon } from '../../../types/energimerke';

// Energimerkeversjon.V2025 use static routes per step. Energimerkeversjon.V2023 uses dynamic routing with step param
// This provider is needed for V2025 until all steps are migrated to V2025, therefore we need to handle both routing
// types
export const useStepFromURL = (energimerkeVersjon?: Energimerkeversjon) => {
  const params = useParams<AllRegistrationScreenParams>();
  const { pathname } = useLocation();
  const { step = RegistrationCommonStep.ABOUT } = params;

  const v2025Step = pathname.split('/')[3] || RegistrationCommonStep.ABOUT;

  return {
    step: energimerkeVersjon === Energimerkeversjon.V2025 ? (v2025Step as RegistrationStep) : (step as RegistrationStep)
  };
};
